// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"1dadf166","319":"acf50f92","447":"facaa161","575":"f7eb9b6e","693":"965793fb","843":"1a2bda2a","983":"a63a5a23"}[chunkId] + ".chunk.js";
};